import apiClient from "../api/apiClient";
import { ENDPOINTS } from "../api/endPoints";
import { createRegisterFormData } from "../models/userModel";

export const registerUser = async (rawUserData, fcmToken) => {
  try {
    const payload = createRegisterFormData(rawUserData, fcmToken);

    console.log("===== FORM DATA PAYLOAD =====");
    for (const [key, value] of payload.entries()) {
      console.log(key, value);
    }
    const response = await apiClient.post(ENDPOINTS.REGISTER_USER, payload);

    console.log("Status code:", response.status);
    console.log("Response data:", response.data);

    return response.data;
  } catch (error) {
    if (error.response?.data?.data) {
      throw new Error(error.response.data.data);
    }

    throw new Error("Something went wrong. Please try again.");
  }
};
